import type {Lang, Widget} from '@yandex-int/messenger.widget'
import React, {useEffect, useState} from 'react'

import {loadMessengerWidgetBundle} from './loader'

export const SupportWidgetContext = React.createContext<Widget | null>(null)

type Props = {
  botID: string
  serviceID: number
  params?: Record<string, unknown>
  lang?: string
  country?: string
  debug?: string
  simple?: boolean
}

const SupportWidgetProvider: React.FC<React.PropsWithChildren<Props>> = ({
  simple,
  country,
  debug,
  botID,
  serviceID,
  params,
  lang,
  children,
}) => {
  const [widget, setWidget] = useState<Widget | null>(null)

  useEffect(() => {
    let supportWidget: Widget | null = null

    window.requestIdleCallback(
      () =>
        loadMessengerWidgetBundle().then(({Widget, YandexSingleChatConfig, popupUIFactory, supportPopupUIFactory}) => {
          const ui = simple ? popupUIFactory({}) : supportPopupUIFactory({})

          supportWidget = new Widget(
            new YandexSingleChatConfig({
              serviceId: serviceID,
              lang: lang as Lang,
              debug,
              flags: {
                disableSettingsButton: '1',
                disableOpenInNewTabButton: '1',
                disableNavigation: '1',
              },
              iframeOpenData: {
                guid: botID,
                context: params,
              },
            }),
          ).setUI(ui)

          supportWidget!.init()

          supportWidget.handlers.getEnv.addListener(request => {
            request.response({country})
          })

          ui.mount()

          setWidget(supportWidget)
        }),
      {timeout: 1000},
    )

    return () => {
      supportWidget?.destroy()
    }
  }, [simple, debug, lang, country, botID, serviceID, params])

  return <SupportWidgetContext.Provider value={widget}>{children}</SupportWidgetContext.Provider>
}

export default SupportWidgetProvider
